import { render, staticRenderFns } from "./PublishSummary.vue?vue&type=template&id=898fdf40&scoped=true&"
import script from "./PublishSummary.vue?vue&type=script&lang=js&"
export * from "./PublishSummary.vue?vue&type=script&lang=js&"
import style0 from "./PublishSummary.vue?vue&type=style&index=0&id=898fdf40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898fdf40",
  null
  
)

export default component.exports